import styled from 'styled-components';
import { Compose, ComposeType } from '../../../Theme/CommonStyled';
export const StyledButton = styled.button<
  ComposeType & {
    errorStatus?: boolean;
    disabled?: boolean;
    loading?: boolean;
  }
>`
  font-family: IRANSans;
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 22px 0;
  border: none;
  border: ${({ theme }): string => theme.borders[0]};
  border-color: ${({ theme, loading }): string =>
    loading ? theme.colors.minorText : theme.colors.primaryGreen};
  font-size: ${({ theme }): string => theme.fontSizes[6]};
  color: ${({ theme, errorStatus, disabled }): string =>
    errorStatus
      ? theme.colors.secondaryButtonText
      : disabled
      ? theme.colors.minorText
      : theme.colors.dark80};
  background-color: ${({ theme, errorStatus, disabled, loading }): string =>
    errorStatus
      ? theme.colors.danger
      : disabled || loading
      ? 'transparent'
      : theme.colors.primaryGreen};
  cursor: pointer;

  ${Compose}

  :disabled {
    border-color: ${({ theme, errorStatus }): string =>
      errorStatus ? theme.colors.danger : theme.colors.minorText};
  }

  .Top-Left {
    position: absolute;
    left: -2px;
    top: -3px;
  }
  .Top-Right {
    position: absolute;
    right: -2px;
    top: -3px;
  }
  .Bottom-Right {
    position: absolute;
    right: -2px;
    bottom: -2px;
  }
  .Bottom-Left {
    position: absolute;
    left: -2px;
    bottom: -2px;
  }
`;
